import { z } from 'zod';

/**
 * NFR-U5: komunikaty walidacji po polsku tam, gdzie schemat nie ma własnego (np. raport importu agendy, błędy API).
 * Ustawienie globalne dla Zod – działa w api i web, bo oba importują `@koderek/shared`.
 */
z.config(z.locales.pl());
